import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private data: any;
  private isEdit = false;

  setData(data: any): void {
    this.data = data;
  }

  getData(): any {
    return this.data;
  }

  setEditMode(edit: boolean): void {
    this.isEdit = edit;
  }

  getEditMode(): boolean {
    return this.isEdit;
  }

}
